import { getAttribute } from "PFCore/helpers/get_attribute";
import { Collection, Id, Option } from "PFTypes";

export type FormattableCustomValue = {
  id?: Id;
  text?: string | boolean;
  value?: string | number | boolean;
};

/**
 * Resolves the identifier used for a custom-value option. Local values expose `id`, while
 * global values only carry `globalId` (camel- or snake-cased depending on the API response).
 */
export const getCustomValueOptionId = (customValue: FormattableCustomValue): Id =>
  customValue.id ?? (getAttribute(customValue as Record<string, unknown>, "globalId") as Id);

/**
 * Maps custom values returned by an autocomplete/service call into the Select `Collection`
 * shape. Consumers keep ownership of the fetching (the params vary widely per field), and pass
 * the result here so the option shape stays consistent across the app.
 */
export const formatCustomValueOptions = <T extends FormattableCustomValue>(
  customValues: T[]
): Collection<Option<T>[]> => {
  const entries = customValues.map((customValue) => ({
    id: getCustomValueOptionId(customValue),
    value: String(customValue.text || customValue.value),
    original: customValue
  }));

  return { entries, meta: { total: entries.length } };
};
